import React from "react";
import { default as MuiCardHeader } from "@mui/material/CardHeader";

function CardHeader(props) {
  return <MuiCardHeader {...props} />;
}

export default CardHeader;
